
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("cs0rL", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $91087245bd29cb20$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $91087245bd29cb20$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($91087245bd29cb20$export$918a9776c0a3cf27 || ($91087245bd29cb20$export$918a9776c0a3cf27 = {}));
var $91087245bd29cb20$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("805AA", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $k3i2h = parcelRequire("k3i2h");

/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5d32a8b5dd5134ea$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $k3i2h.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $hXuPC.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $5d32a8b5dd5134ea$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $5d32a8b5dd5134ea$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $5d32a8b5dd5134ea$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $5d32a8b5dd5134ea$var$callOnHub('captureMessage', message, level, (0, $hXuPC.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $5d32a8b5dd5134ea$export$1462b974fdcf6ba2(event) {
    return $5d32a8b5dd5134ea$var$callOnHub('captureEvent', event);
}
function $5d32a8b5dd5134ea$export$99d44f04437e9cb8(callback) {
    $5d32a8b5dd5134ea$var$callOnHub('configureScope', callback);
}
function $5d32a8b5dd5134ea$export$efda9a273d7a036d(breadcrumb) {
    $5d32a8b5dd5134ea$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $5d32a8b5dd5134ea$export$2f04de43fe27971a(name, context) {
    $5d32a8b5dd5134ea$var$callOnHub('setContext', name, context);
}
function $5d32a8b5dd5134ea$export$bb4922da0dd51b92(extras) {
    $5d32a8b5dd5134ea$var$callOnHub('setExtras', extras);
}
function $5d32a8b5dd5134ea$export$74a8fb34822092e6(tags) {
    $5d32a8b5dd5134ea$var$callOnHub('setTags', tags);
}
function $5d32a8b5dd5134ea$export$8e8e7789d42ed61d(key, extra) {
    $5d32a8b5dd5134ea$var$callOnHub('setExtra', key, extra);
}
function $5d32a8b5dd5134ea$export$a37d07ee78eb4569(key, value) {
    $5d32a8b5dd5134ea$var$callOnHub('setTag', key, value);
}
function $5d32a8b5dd5134ea$export$8b6bb3dd62a01be2(user) {
    $5d32a8b5dd5134ea$var$callOnHub('setUser', user);
}
function $5d32a8b5dd5134ea$export$ec58d9285c204497(callback) {
    $5d32a8b5dd5134ea$var$callOnHub('withScope', callback);
}
function $5d32a8b5dd5134ea$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $5d32a8b5dd5134ea$var$callOnHub.apply(void 0, (0, $hXuPC.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $5d32a8b5dd5134ea$export$e262da7ae6480481(context, customSamplingContext) {
    return $5d32a8b5dd5134ea$var$callOnHub('startTransaction', (0, $hXuPC.__assign)({}, context), customSamplingContext);
}
module.exports["captureException"] = $5d32a8b5dd5134ea$export$f5282963edea4a68;
module.exports["captureMessage"] = $5d32a8b5dd5134ea$export$45654777c133ae80;
module.exports["captureEvent"] = $5d32a8b5dd5134ea$export$1462b974fdcf6ba2;
module.exports["configureScope"] = $5d32a8b5dd5134ea$export$99d44f04437e9cb8;
module.exports["addBreadcrumb"] = $5d32a8b5dd5134ea$export$efda9a273d7a036d;
module.exports["setContext"] = $5d32a8b5dd5134ea$export$2f04de43fe27971a;
module.exports["setExtras"] = $5d32a8b5dd5134ea$export$bb4922da0dd51b92;
module.exports["setTags"] = $5d32a8b5dd5134ea$export$74a8fb34822092e6;
module.exports["setExtra"] = $5d32a8b5dd5134ea$export$8e8e7789d42ed61d;
module.exports["setTag"] = $5d32a8b5dd5134ea$export$a37d07ee78eb4569;
module.exports["setUser"] = $5d32a8b5dd5134ea$export$8b6bb3dd62a01be2;
module.exports["withScope"] = $5d32a8b5dd5134ea$export$ec58d9285c204497;
module.exports["startTransaction"] = $5d32a8b5dd5134ea$export$e262da7ae6480481;

});

parcelRegister("k3i2h", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("eO92b");
var $4e7HY = parcelRequire("4e7HY");
var $gBQDZ = parcelRequire("gBQDZ");
var $i3eBC = parcelRequire("i3eBC");
var $5Bdij = parcelRequire("5Bdij");
var $laILM = parcelRequire("laILM");

/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $d0bed6609732f1a8$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;



var $euURg = parcelRequire("euURg");


var $cSJat = parcelRequire("cSJat");

var $e99213ff534d7966$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $e99213ff534d7966$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $e99213ff534d7966$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $euURg.Scope)();
        if (_version === void 0) _version = $e99213ff534d7966$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $euURg.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $laILM.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $laILM.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $laILM.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $e99213ff534d7966$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $gBQDZ.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $hXuPC.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $4e7HY.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $e99213ff534d7966$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $e99213ff534d7966$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $d0bed6609732f1a8$export$48a8984ec0bf2e44) && (0, $4e7HY.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $i3eBC.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $cSJat.Session)((0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $hXuPC.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $e99213ff534d7966$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $d0bed6609732f1a8$export$48a8984ec0bf2e44) && (0, $4e7HY.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $e99213ff534d7966$export$19eade501500c6c1() {
    var carrier = (0, $i3eBC.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $e99213ff534d7966$export$4188a14ad302d1bc(hub) {
    var registry = $e99213ff534d7966$export$19eade501500c6c1();
    var oldHub = $e99213ff534d7966$export$bfa8a924a84a76b7(registry);
    $e99213ff534d7966$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $e99213ff534d7966$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $e99213ff534d7966$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$e99213ff534d7966$var$hasHubOnCarrier(registry) || $e99213ff534d7966$export$bfa8a924a84a76b7(registry).isOlderThan($e99213ff534d7966$export$24a86ef7798177e4)) $e99213ff534d7966$export$849f05434e95d2f2(registry, new $e99213ff534d7966$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $5Bdij.isNodeEnv)()) return $e99213ff534d7966$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $e99213ff534d7966$export$bfa8a924a84a76b7(registry);
}
function $e99213ff534d7966$export$1c4d656130202699() {
    (0, $d0bed6609732f1a8$export$48a8984ec0bf2e44) && (0, $4e7HY.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $e99213ff534d7966$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $e99213ff534d7966$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $e99213ff534d7966$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $e99213ff534d7966$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$e99213ff534d7966$var$hasHubOnCarrier(activeDomain) || $e99213ff534d7966$export$bfa8a924a84a76b7(activeDomain).isOlderThan($e99213ff534d7966$export$24a86ef7798177e4)) {
            var registryHubTopStack = $e99213ff534d7966$export$bfa8a924a84a76b7(registry).getStackTop();
            $e99213ff534d7966$export$849f05434e95d2f2(activeDomain, new $e99213ff534d7966$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $euURg.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $e99213ff534d7966$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $e99213ff534d7966$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $e99213ff534d7966$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $e99213ff534d7966$export$bfa8a924a84a76b7(carrier) {
    return (0, $i3eBC.getGlobalSingleton)('hub', function() {
        return new $e99213ff534d7966$export$8c41bb232f1008b1();
    }, carrier);
}
function $e99213ff534d7966$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}
module.exports["Hub"] = $e99213ff534d7966$export$8c41bb232f1008b1;
module.exports["makeMain"] = $e99213ff534d7966$export$4188a14ad302d1bc;
module.exports["getHubFromCarrier"] = $e99213ff534d7966$export$bfa8a924a84a76b7;
module.exports["getCurrentHub"] = $e99213ff534d7966$export$a07cdf6544bbd7c;

});

parcelRegister("5Bdij", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $d4v4U = parcelRequire("d4v4U");


var $kyRHQ = parcelRequire("kyRHQ");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $d4v4U.isBrowserBundle)() && Object.prototype.toString.call(typeof $kyRHQ !== 'undefined' ? $kyRHQ : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});

parcelRegister("gBQDZ", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $i3eBC = parcelRequire("i3eBC");


var $5Bdij = parcelRequire("5Bdij");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $i3eBC.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5Bdij.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5Bdij.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $i3eBC.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("euURg", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("eO92b");
var $gBQDZ = parcelRequire("gBQDZ");
var $i3eBC = parcelRequire("i3eBC");
var $4EsX1 = parcelRequire("4EsX1");
var $guynL = parcelRequire("guynL");

/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $a8dff8deb7524298$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $a8dff8deb7524298$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $hXuPC.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $hXuPC.__assign)({}, scope._tags);
            newScope._extra = (0, $hXuPC.__assign)({}, scope._extra);
            newScope._contexts = (0, $hXuPC.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $hXuPC.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $4EsX1.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $a8dff8deb7524298$var$MAX_BREADCRUMBS) : $a8dff8deb7524298$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $hXuPC.__assign)({
            timestamp: (0, $gBQDZ.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $hXuPC.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $hXuPC.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $hXuPC.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $hXuPC.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $hXuPC.__spread)($a8dff8deb7524298$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $guynL.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $hXuPC.__assign)({}, event), hint);
                if ((0, $4EsX1.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $a8dff8deb7524298$var$getGlobalEventProcessors() {
    return (0, $i3eBC.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $a8dff8deb7524298$export$8e4e25f54d456511(callback) {
    $a8dff8deb7524298$var$getGlobalEventProcessors().push(callback);
}
module.exports["Scope"] = $a8dff8deb7524298$export$775b6bb06e53a214;
module.exports["addGlobalEventProcessor"] = $a8dff8deb7524298$export$8e4e25f54d456511;

});

parcelRegister("cSJat", function(module, exports) {
parcelRequire("eO92b");
var $a3b6c = parcelRequire("a3b6c");
var $gBQDZ = parcelRequire("gBQDZ");
var $laILM = parcelRequire("laILM");

/**
 * @inheritdoc
 */ var $960d909b938c4d22$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $laILM.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $gBQDZ.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $gBQDZ.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $laILM.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $a3b6c.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();
module.exports["Session"] = $960d909b938c4d22$export$1fb4852a55678982;

});

parcelRegister("cTFwF", function(module, exports) {
var $963ad5446d1675e3$export$31499a9cd224b78c = '6.19.7';
module.exports["SDK_VERSION"] = $963ad5446d1675e3$export$31499a9cd224b78c;

});

parcelRegister("cW7ac", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");





var $euURg = parcelRequire("euURg");

parcelRequire("fkDf0");
var $MPsF3 = parcelRequire("MPsF3");
var $aYCCb = parcelRequire("aYCCb");
var $9HZPI = parcelRequire("9HZPI");
var $cocLa = parcelRequire("cocLa");
var $2V24C = parcelRequire("2V24C");
var $gqhQh = parcelRequire("gqhQh");
var $jzoXR = parcelRequire("jzoXR");
var $fS7TC = parcelRequire("fS7TC");
var $jsTR9 = parcelRequire("jsTR9");


var $2TDhi = parcelRequire("2TDhi");







var $k3i2h = parcelRequire("k3i2h");

parcelRequire("fkDf0");
var $eZrYr = parcelRequire("eZrYr");




var $e085f4cfa5ab0c7f$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $e085f4cfa5ab0c7f$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $e085f4cfa5ab0c7f$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $hXuPC.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $hXuPC.__spread)($e085f4cfa5ab0c7f$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $hXuPC.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $e085f4cfa5ab0c7f$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $hXuPC.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $e085f4cfa5ab0c7f$export$e7390a03b70a6f2f(integration) {
    if ($e085f4cfa5ab0c7f$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $euURg.addGlobalEventProcessor), (0, $k3i2h.getCurrentHub));
    $e085f4cfa5ab0c7f$export$b14a8888f80a0b3e.push(integration.name);
    (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).log("Integration installed: " + integration.name);
}
function $e085f4cfa5ab0c7f$export$51abed9797baa598(options) {
    var integrations = {};
    $e085f4cfa5ab0c7f$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $e085f4cfa5ab0c7f$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $eZrYr.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}


var $bbbe9ca468c1f690$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $bbbe9ca468c1f690$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $2V24C.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $MPsF3.checkOrSetAlreadyCaught)(exception)) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).log($bbbe9ca468c1f690$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $9HZPI.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $MPsF3.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).log($bbbe9ca468c1f690$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $e085f4cfa5ab0c7f$export$51abed9797baa598)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $hXuPC.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $jzoXR.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $MPsF3.uuid4)()),
            timestamp: event.timestamp || (0, $aYCCb.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $euURg.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $jzoXR.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $gqhQh.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, b), b.data && {
                    data: (0, $gqhQh.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $gqhQh.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $gqhQh.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $gqhQh.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $jsTR9.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $jsTR9.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $jsTR9.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $hXuPC.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $jzoXR.rejectedSyncPromise)(new (0, $fS7TC.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $jzoXR.rejectedSyncPromise)(new (0, $fS7TC.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $fS7TC.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $bbbe9ca468c1f690$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $fS7TC.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $fS7TC.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $fS7TC.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $bbbe9ca468c1f690$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $9HZPI.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $9HZPI.isPlainObject)(event) || event === null)) throw new (0, $fS7TC.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $fS7TC.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $9HZPI.isPlainObject)(rv) || rv === null)) throw new (0, $fS7TC.SentryError)(nullErr);
    return rv;
}


var $cTFwF = parcelRequire("cTFwF");

parcelRequire("fkDf0");
var $4eANt = parcelRequire("4eANt");







parcelRequire("fkDf0");



var $is9T0 = parcelRequire("is9T0");





var $kGXHg = parcelRequire("kGXHg");

parcelRequire("fkDf0");


/** Noop transport */ var $d4071b73602266ab$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $jzoXR.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $jzoXR.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();


/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $40d723e1be53b978$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $fS7TC.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $fS7TC.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $is9T0.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $kGXHg.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $is9T0.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $hXuPC.__read)((0, $kGXHg.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $d4071b73602266ab$export$6f2767450ea1346c)();
    };
    return BaseBackend;
}();





var $cs0rL = parcelRequire("cs0rL");

parcelRequire("fkDf0");
var $6eHR6 = parcelRequire("6eHR6");


var $a7P2i = parcelRequire("a7P2i");


var $8LVWj = parcelRequire("8LVWj");

var $hB2rb = parcelRequire("hB2rb");

var $lgAM0 = parcelRequire("lgAM0");

var $2yXKF = parcelRequire("2yXKF");

/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $55a4d96a04dac44e$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $a7P2i.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $cs0rL.Severity).Info;
        return (0, $a7P2i.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $is9T0.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $is9T0.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $6eHR6.supportsFetch)()) {
            var requestOptions = (0, $hXuPC.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $hB2rb.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $8LVWj.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $lgAM0.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $2yXKF.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $40d723e1be53b978$export$8f43a53a38d7e95f));



var $cieCg = parcelRequire("cieCg");


var $1cvC0 = parcelRequire("1cvC0");


var $bISXm = parcelRequire("bISXm");

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $96b0755cfc30a15f$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $cTFwF.SDK_VERSION)
                }
            ],
            version: (0, $cTFwF.SDK_VERSION)
        };
        _this = _super.call(this, (0, $55a4d96a04dac44e$export$2526e21aec9d0ce7), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $4eANt.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $1cvC0.injectReportDialog)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $bISXm.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $bbbe9ca468c1f690$export$4f22f74eddb7716a));
module.exports["BrowserClient"] = $96b0755cfc30a15f$export$1df9218a526d318d;

});

parcelRegister("fkDf0", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("aqDlz")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("xU7pz")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("xU7pz")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("2V24C")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("2V24C")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("fS7TC")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("4eANt")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("1J0Am")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("9HZPI")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("9HZPI")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("9HZPI")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("9HZPI")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("9HZPI")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("9HZPI")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("9HZPI")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("9HZPI")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("9HZPI")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("9HZPI")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("cocLa")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("MPsF3")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("MPsF3")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("MPsF3")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("MPsF3")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("MPsF3")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("MPsF3")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("gqhQh")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("gqhQh")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("eZrYr")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("eZrYr")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("eZrYr")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("eZrYr")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("eZrYr")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("eZrYr")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("8TkNe")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("eEOR0")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("3sZrb")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("3sZrb")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("aXefL")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("jsTR9")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("jsTR9")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("jsTR9")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("6eHR6")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("6eHR6")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("6eHR6")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("jzoXR")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("jzoXR")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("jzoXR")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("2yJF3")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("2yJF3")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("2yJF3")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("1D7cA")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("bc0x7")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("bc0x7")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("bc0x7")).updateRateLimits);
parcelRequire("aqDlz");

parcelRequire("xU7pz");

parcelRequire("2V24C");


parcelRequire("fS7TC");

parcelRequire("4eANt");

parcelRequire("1J0Am");

parcelRequire("9HZPI");

parcelRequire("cocLa");


parcelRequire("MPsF3");


var $56dzl = parcelRequire("56dzl");

parcelRequire("gqhQh");

parcelRequire("eZrYr");


parcelRequire("8TkNe");

parcelRequire("eEOR0");

parcelRequire("3sZrb");

parcelRequire("aXefL");

parcelRequire("jsTR9");

parcelRequire("6eHR6");

parcelRequire("jzoXR");


var $aYCCb = parcelRequire("aYCCb");



parcelRequire("2yJF3");

parcelRequire("1D7cA");

parcelRequire("bc0x7");

$parcel$exportWildcard(module.exports, $56dzl);
$parcel$exportWildcard(module.exports, $aYCCb);

});

parcelRegister("56dzl", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $d4wHl = parcelRequire("d4wHl");


var $kyRHQ = parcelRequire("kyRHQ");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $d4wHl.isBrowserBundle)() && Object.prototype.toString.call(typeof $kyRHQ !== 'undefined' ? $kyRHQ : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});

parcelRegister("aYCCb", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $4eANt = parcelRequire("4eANt");


var $56dzl = parcelRequire("56dzl");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $4eANt.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $56dzl.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $56dzl.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $4eANt.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("a7P2i", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $cs0rL = parcelRequire("cs0rL");

parcelRequire("fkDf0");
var $MPsF3 = parcelRequire("MPsF3");
var $3sZrb = parcelRequire("3sZrb");
var $eZrYr = parcelRequire("eZrYr");
var $9HZPI = parcelRequire("9HZPI");
var $gqhQh = parcelRequire("gqhQh");
var $jzoXR = parcelRequire("jzoXR");




// global reference to slice
var $3c38045f7bbea0b4$var$UNKNOWN_FUNCTION = '?';
var $3c38045f7bbea0b4$var$OPERA10_PRIORITY = 10;
var $3c38045f7bbea0b4$var$OPERA11_PRIORITY = 20;
var $3c38045f7bbea0b4$var$CHROME_PRIORITY = 30;
var $3c38045f7bbea0b4$var$WINJS_PRIORITY = 40;
var $3c38045f7bbea0b4$var$GECKO_PRIORITY = 50;
function $3c38045f7bbea0b4$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $3c38045f7bbea0b4$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $3c38045f7bbea0b4$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $3c38045f7bbea0b4$var$chrome = function(line) {
    var parts = $3c38045f7bbea0b4$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $3c38045f7bbea0b4$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $hXuPC.__read)($3c38045f7bbea0b4$var$extractSafariExtensionDetails(parts[1] || $3c38045f7bbea0b4$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $3c38045f7bbea0b4$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $3c38045f7bbea0b4$export$c693d9295441d8f9 = [
    $3c38045f7bbea0b4$var$CHROME_PRIORITY,
    $3c38045f7bbea0b4$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $3c38045f7bbea0b4$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $3c38045f7bbea0b4$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $3c38045f7bbea0b4$var$gecko = function(line) {
    var _a;
    var parts = $3c38045f7bbea0b4$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $3c38045f7bbea0b4$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $3c38045f7bbea0b4$var$UNKNOWN_FUNCTION;
        _a = (0, $hXuPC.__read)($3c38045f7bbea0b4$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $3c38045f7bbea0b4$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $3c38045f7bbea0b4$export$c9ddf1e2b5d48bff = [
    $3c38045f7bbea0b4$var$GECKO_PRIORITY,
    $3c38045f7bbea0b4$var$gecko
];
var $3c38045f7bbea0b4$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $3c38045f7bbea0b4$var$winjs = function(line) {
    var parts = $3c38045f7bbea0b4$var$winjsRegex.exec(line);
    return parts ? $3c38045f7bbea0b4$var$createFrame(parts[2], parts[1] || $3c38045f7bbea0b4$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $3c38045f7bbea0b4$export$b6d155d85c1dcba5 = [
    $3c38045f7bbea0b4$var$WINJS_PRIORITY,
    $3c38045f7bbea0b4$var$winjs
];
var $3c38045f7bbea0b4$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $3c38045f7bbea0b4$var$opera10 = function(line) {
    var parts = $3c38045f7bbea0b4$var$opera10Regex.exec(line);
    return parts ? $3c38045f7bbea0b4$var$createFrame(parts[2], parts[3] || $3c38045f7bbea0b4$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $3c38045f7bbea0b4$export$966ec832d9699d6 = [
    $3c38045f7bbea0b4$var$OPERA10_PRIORITY,
    $3c38045f7bbea0b4$var$opera10
];
var $3c38045f7bbea0b4$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $3c38045f7bbea0b4$var$opera11 = function(line) {
    var parts = $3c38045f7bbea0b4$var$opera11Regex.exec(line);
    return parts ? $3c38045f7bbea0b4$var$createFrame(parts[5], parts[3] || parts[4] || $3c38045f7bbea0b4$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $3c38045f7bbea0b4$export$989a1824b4734ce6 = [
    $3c38045f7bbea0b4$var$OPERA11_PRIORITY,
    $3c38045f7bbea0b4$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $3c38045f7bbea0b4$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $3c38045f7bbea0b4$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};


function $75f22587aecf452f$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $75f22587aecf452f$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $75f22587aecf452f$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $75f22587aecf452f$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $9HZPI.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $eZrYr.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $gqhQh.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $75f22587aecf452f$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $75f22587aecf452f$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $75f22587aecf452f$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $75f22587aecf452f$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $75f22587aecf452f$var$getPopSize(ex);
    try {
        return (0, $3sZrb.createStackParser)((0, $3c38045f7bbea0b4$export$966ec832d9699d6), (0, $3c38045f7bbea0b4$export$989a1824b4734ce6), (0, $3c38045f7bbea0b4$export$c693d9295441d8f9), (0, $3c38045f7bbea0b4$export$b6d155d85c1dcba5), (0, $3c38045f7bbea0b4$export$c9ddf1e2b5d48bff))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $75f22587aecf452f$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $75f22587aecf452f$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($75f22587aecf452f$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $75f22587aecf452f$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $75f22587aecf452f$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $75f22587aecf452f$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $MPsF3.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $cs0rL.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $jzoXR.resolvedSyncPromise)(event);
}
function $75f22587aecf452f$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $cs0rL.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $75f22587aecf452f$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $jzoXR.resolvedSyncPromise)(event);
}
function $75f22587aecf452f$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $9HZPI.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $75f22587aecf452f$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9HZPI.isDOMError)(exception) || (0, $9HZPI.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $75f22587aecf452f$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $9HZPI.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $75f22587aecf452f$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $MPsF3.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $9HZPI.isError)(exception)) // we have a real Error object, do nothing
    return $75f22587aecf452f$export$73fbea5a0a5234af(exception);
    if ((0, $9HZPI.isPlainObject)(exception) || (0, $9HZPI.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $75f22587aecf452f$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $MPsF3.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $75f22587aecf452f$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $MPsF3.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $MPsF3.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $75f22587aecf452f$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $75f22587aecf452f$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}
module.exports["exceptionFromError"] = $75f22587aecf452f$export$a6c2d27607295951;
module.exports["eventFromException"] = $75f22587aecf452f$export$ea3ec7e569b823fc;
module.exports["eventFromUnknownInput"] = $75f22587aecf452f$export$9dd56ed1ef0c3420;
module.exports["eventFromMessage"] = $75f22587aecf452f$export$5425b53185d13d6c;

});

parcelRegister("8LVWj", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("fkDf0");
var $fS7TC = parcelRequire("fS7TC");
var $6eHR6 = parcelRequire("6eHR6");
var $jzoXR = parcelRequire("jzoXR");


var $1l2dO = parcelRequire("1l2dO");


var $hoi63 = parcelRequire("hoi63");

/** `fetch` based transport */ var $662fa81a986f3c84$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $hoi63.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $6eHR6.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $jzoXR.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $fS7TC.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $1l2dO.BaseTransport));
module.exports["FetchTransport"] = $662fa81a986f3c84$export$2bdee3f9b92f4e82;

});

parcelRegister("1l2dO", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $kGXHg = parcelRequire("kGXHg");

var $is9T0 = parcelRequire("is9T0");

parcelRequire("fkDf0");
var $1D7cA = parcelRequire("1D7cA");
var $bc0x7 = parcelRequire("bc0x7");
var $2V24C = parcelRequire("2V24C");
var $aXefL = parcelRequire("aXefL");
var $4eANt = parcelRequire("4eANt");
var $cocLa = parcelRequire("cocLa");
var $8TkNe = parcelRequire("8TkNe");
var $2yJF3 = parcelRequire("2yJF3");


var $cieCg = parcelRequire("cieCg");


var $hoi63 = parcelRequire("hoi63");

function $0f9979cc3c9ba12f$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $0f9979cc3c9ba12f$var$global = (0, $4eANt.getGlobalObject)();
/** Base Transport class implementation */ var $0f9979cc3c9ba12f$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $8TkNe.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $is9T0.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $is9T0.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $0f9979cc3c9ba12f$var$global.document) $0f9979cc3c9ba12f$var$global.document.addEventListener('visibilitychange', function() {
            if ($0f9979cc3c9ba12f$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $kGXHg.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $kGXHg.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $0f9979cc3c9ba12f$var$requestTypeToCategory(category) + ":" + reason;
        (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).log('No outcomes to flush');
            return;
        }
        (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $is9T0.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $hXuPC.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $1D7cA.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $2V24C.dsnToString)(this._api.dsn));
        try {
            (0, $hoi63.sendReport)(url, (0, $2yJF3.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $aXefL.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $bc0x7.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $cieCg.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $cocLa.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $0f9979cc3c9ba12f$var$requestTypeToCategory(requestType);
        return new Date((0, $bc0x7.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $0f9979cc3c9ba12f$var$requestTypeToCategory(requestType);
        return (0, $bc0x7.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();
module.exports["BaseTransport"] = $0f9979cc3c9ba12f$export$74b99d619e90f481;

});

parcelRegister("hB2rb", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $UVxe5 = parcelRequire("UVxe5");


var $hoi63 = parcelRequire("hoi63");

function $034e51af10706f1b$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $hoi63.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $hXuPC.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $UVxe5.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}
module.exports["makeNewFetchTransport"] = $034e51af10706f1b$export$1c57e6bfd09bad13;

});

parcelRegister("lgAM0", function(module, exports) {

var $UVxe5 = parcelRequire("UVxe5");

parcelRequire("fkDf0");
var $jzoXR = parcelRequire("jzoXR");

/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $f7b79dfdb70cd47c$var$XHR_READYSTATE_DONE = 4;
function $f7b79dfdb70cd47c$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $jzoXR.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $f7b79dfdb70cd47c$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $UVxe5.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}
module.exports["makeNewXHRTransport"] = $f7b79dfdb70cd47c$export$4c0ac1dd4bbf4921;

});

parcelRegister("2yXKF", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("fkDf0");
var $fS7TC = parcelRequire("fS7TC");
var $jzoXR = parcelRequire("jzoXR");


var $1l2dO = parcelRequire("1l2dO");

/** `XHR` based transport */ var $1ddd1b2fdefb369d$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $jzoXR.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $fS7TC.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $1l2dO.BaseTransport));
module.exports["XHRTransport"] = $1ddd1b2fdefb369d$export$874a283af77e8e62;

});

parcelRegister("1cvC0", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $805AA = parcelRequire("805AA");

var $is9T0 = parcelRequire("is9T0");

parcelRequire("fkDf0");
var $MPsF3 = parcelRequire("MPsF3");
var $eZrYr = parcelRequire("eZrYr");
var $4eANt = parcelRequire("4eANt");
var $cocLa = parcelRequire("cocLa");


var $cieCg = parcelRequire("cieCg");

var $0dff6eefc8b92542$var$global = (0, $4eANt.getGlobalObject)();
var $0dff6eefc8b92542$var$ignoreOnError = 0;
function $0dff6eefc8b92542$export$b79738ab10c590b2() {
    return $0dff6eefc8b92542$var$ignoreOnError > 0;
}
function $0dff6eefc8b92542$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $0dff6eefc8b92542$var$ignoreOnError += 1;
    setTimeout(function() {
        $0dff6eefc8b92542$var$ignoreOnError -= 1;
    });
}
function $0dff6eefc8b92542$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $eZrYr.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $0dff6eefc8b92542$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $0dff6eefc8b92542$export$1265a142ff5ba165();
            (0, $805AA.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $MPsF3.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $MPsF3.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $805AA.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $eZrYr.markFunctionWrapped)(sentryWrapped, fn);
    (0, $eZrYr.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $0dff6eefc8b92542$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$0dff6eefc8b92542$var$global.document) return;
    if (!options.eventId) {
        (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $0dff6eefc8b92542$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $is9T0.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $0dff6eefc8b92542$var$global.document.head || $0dff6eefc8b92542$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}
module.exports["shouldIgnoreOnError"] = $0dff6eefc8b92542$export$b79738ab10c590b2;
module.exports["wrap"] = $0dff6eefc8b92542$export$4997ffc0176396a6;
module.exports["injectReportDialog"] = $0dff6eefc8b92542$export$deb9aac8ea0b576c;

});

parcelRegister("bISXm", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $k3i2h = parcelRequire("k3i2h");


var $cs0rL = parcelRequire("cs0rL");

parcelRequire("fkDf0");
var $1J0Am = parcelRequire("1J0Am");
var $MPsF3 = parcelRequire("MPsF3");
var $4eANt = parcelRequire("4eANt");
var $xU7pz = parcelRequire("xU7pz");
var $jsTR9 = parcelRequire("jsTR9");
var $eEOR0 = parcelRequire("eEOR0");

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $888e6ef8089ab592$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $hXuPC.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $k3i2h.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $MPsF3.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $1J0Am.addInstrumentationHandler)('console', $888e6ef8089ab592$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $1J0Am.addInstrumentationHandler)('dom', $888e6ef8089ab592$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $1J0Am.addInstrumentationHandler)('xhr', $888e6ef8089ab592$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $1J0Am.addInstrumentationHandler)('fetch', $888e6ef8089ab592$var$_fetchBreadcrumb);
        if (this._options.history) (0, $1J0Am.addInstrumentationHandler)('history', $888e6ef8089ab592$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $888e6ef8089ab592$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $xU7pz.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $xU7pz.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $k3i2h.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $888e6ef8089ab592$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $eEOR0.severityFromString)(handlerData.level),
        message: (0, $jsTR9.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $jsTR9.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $k3i2h.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $888e6ef8089ab592$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $k3i2h.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $888e6ef8089ab592$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $k3i2h.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $cs0rL.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $k3i2h.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $888e6ef8089ab592$var$_historyBreadcrumb(handlerData) {
    var global = (0, $4eANt.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $MPsF3.parseUrl)(global.location.href);
    var parsedFrom = (0, $MPsF3.parseUrl)(from);
    var parsedTo = (0, $MPsF3.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $k3i2h.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}
module.exports["Breadcrumbs"] = $888e6ef8089ab592$export$2dc68d50d56fbbd;

});

parcelRegister("ffG6S", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $k3i2h = parcelRequire("k3i2h");



parcelRequire("fkDf0");
var $cocLa = parcelRequire("cocLa");


var $2TDhi = parcelRequire("2TDhi");

function $550bae1f3538715c$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $2TDhi.IS_DEBUG_BUILD) (0, $cocLa.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $k3i2h.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}


var $a5jIU = parcelRequire("a5jIU");

parcelRequire("fkDf0");
var $1J0Am = parcelRequire("1J0Am");
var $4eANt = parcelRequire("4eANt");
var $jzoXR = parcelRequire("jzoXR");


var $cW7ac = parcelRequire("cW7ac");


var $cieCg = parcelRequire("cieCg");


var $1cvC0 = parcelRequire("1cvC0");


var $bISXm = parcelRequire("bISXm");

var $fCIwr = parcelRequire("fCIwr");

var $3BsQh = parcelRequire("3BsQh");

var $63fUW = parcelRequire("63fUW");

var $lIIKi = parcelRequire("lIIKi");

var $eLUbA = parcelRequire("eLUbA");

var $02dd903113a4975b$export$5ef831fccfce35e5 = [
    new (0, $a5jIU).InboundFilters(),
    new (0, $a5jIU).FunctionToString(),
    new (0, $lIIKi.TryCatch)(),
    new (0, $bISXm.Breadcrumbs)(),
    new (0, $3BsQh.GlobalHandlers)(),
    new (0, $63fUW.LinkedErrors)(),
    new (0, $fCIwr.Dedupe)(),
    new (0, $eLUbA.UserAgent)()
];
function $02dd903113a4975b$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $02dd903113a4975b$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $4eANt.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $550bae1f3538715c$export$5333c3f1c58d9bc1)((0, $cW7ac.BrowserClient), options);
    if (options.autoSessionTracking) $02dd903113a4975b$var$startSessionTracking();
}
function $02dd903113a4975b$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $k3i2h.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $02dd903113a4975b$export$5d4e9fd7fac8e617() {
    return (0, $k3i2h.getCurrentHub)().lastEventId();
}
function $02dd903113a4975b$export$a3f323d81eede727() {
// Noop
}
function $02dd903113a4975b$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $02dd903113a4975b$export$4909b86c8034bf73(timeout) {
    var client = (0, $k3i2h.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('Cannot flush events. No client defined.');
    return (0, $jzoXR.resolvedSyncPromise)(false);
}
function $02dd903113a4975b$export$8360e631d277ea4d(timeout) {
    var client = (0, $k3i2h.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $jzoXR.resolvedSyncPromise)(false);
}
function $02dd903113a4975b$export$4997ffc0176396a6(fn) {
    return (0, $1cvC0.wrap)(fn)();
}
function $02dd903113a4975b$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $02dd903113a4975b$var$startSessionTracking() {
    var window = (0, $4eANt.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $k3i2h.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $02dd903113a4975b$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $1J0Am.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $02dd903113a4975b$var$startSessionOnHub((0, $k3i2h.getCurrentHub)());
    });
}
module.exports["defaultIntegrations"] = $02dd903113a4975b$export$5ef831fccfce35e5;
module.exports["init"] = $02dd903113a4975b$export$2cd8252107eb640b;
module.exports["showReportDialog"] = $02dd903113a4975b$export$3a8fd680da42627b;
module.exports["lastEventId"] = $02dd903113a4975b$export$5d4e9fd7fac8e617;
module.exports["forceLoad"] = $02dd903113a4975b$export$a3f323d81eede727;
module.exports["onLoad"] = $02dd903113a4975b$export$4e4d8b287d028b6b;
module.exports["flush"] = $02dd903113a4975b$export$4909b86c8034bf73;
module.exports["close"] = $02dd903113a4975b$export$8360e631d277ea4d;
module.exports["wrap"] = $02dd903113a4975b$export$4997ffc0176396a6;

});

parcelRegister("a5jIU", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("eQWVr")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("22rCx")).InboundFilters);

var $eQWVr = parcelRequire("eQWVr");


var $22rCx = parcelRequire("22rCx");


});

parcelRegister("fCIwr", function(module, exports) {
parcelRequire("fkDf0");
var $cocLa = parcelRequire("cocLa");


var $cieCg = parcelRequire("cieCg");

/** Deduplication filter */ var $b5fcf0d55f43cc9a$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($b5fcf0d55f43cc9a$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $b5fcf0d55f43cc9a$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b5fcf0d55f43cc9a$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b5fcf0d55f43cc9a$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $b5fcf0d55f43cc9a$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b5fcf0d55f43cc9a$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b5fcf0d55f43cc9a$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $b5fcf0d55f43cc9a$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $b5fcf0d55f43cc9a$var$_getExceptionFromEvent(previousEvent);
    var currentException = $b5fcf0d55f43cc9a$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b5fcf0d55f43cc9a$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b5fcf0d55f43cc9a$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $b5fcf0d55f43cc9a$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $b5fcf0d55f43cc9a$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $b5fcf0d55f43cc9a$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $b5fcf0d55f43cc9a$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $b5fcf0d55f43cc9a$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $b5fcf0d55f43cc9a$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}
module.exports["Dedupe"] = $b5fcf0d55f43cc9a$export$688d98c249d31ad3;

});

parcelRegister("3BsQh", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $k3i2h = parcelRequire("k3i2h");


var $cs0rL = parcelRequire("cs0rL");

parcelRequire("fkDf0");
var $MPsF3 = parcelRequire("MPsF3");
var $1J0Am = parcelRequire("1J0Am");
var $xU7pz = parcelRequire("xU7pz");
var $9HZPI = parcelRequire("9HZPI");
var $cocLa = parcelRequire("cocLa");


var $a7P2i = parcelRequire("a7P2i");


var $cieCg = parcelRequire("cieCg");


var $1cvC0 = parcelRequire("1cvC0");

/** Global handlers */ var $29fb333d21db3d14$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $29fb333d21db3d14$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $29fb333d21db3d14$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $hXuPC.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $29fb333d21db3d14$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $29fb333d21db3d14$var$_installGlobalOnErrorHandler() {
    (0, $1J0Am.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $hXuPC.__read)($29fb333d21db3d14$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($29fb333d21db3d14$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $1cvC0.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $9HZPI.isString)(msg) ? $29fb333d21db3d14$var$_eventFromIncompleteOnError(msg, url, line, column) : $29fb333d21db3d14$var$_enhanceEventWithInitialFrame((0, $a7P2i.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $cs0rL.Severity).Error;
        $29fb333d21db3d14$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $29fb333d21db3d14$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $1J0Am.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $hXuPC.__read)($29fb333d21db3d14$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($29fb333d21db3d14$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $1cvC0.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $9HZPI.isPrimitive)(error) ? $29fb333d21db3d14$var$_eventFromRejectionWithPrimitive(error) : (0, $a7P2i.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $cs0rL.Severity).Error;
        $29fb333d21db3d14$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $29fb333d21db3d14$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $29fb333d21db3d14$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $9HZPI.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $29fb333d21db3d14$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $29fb333d21db3d14$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $9HZPI.isString)(url) && url.length > 0 ? url : (0, $xU7pz.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $29fb333d21db3d14$var$globalHandlerLog(type) {
    (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).log("Global Handler attached: " + type);
}
function $29fb333d21db3d14$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $MPsF3.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $29fb333d21db3d14$var$getHubAndAttachStacktrace() {
    var hub = (0, $k3i2h.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}
module.exports["GlobalHandlers"] = $29fb333d21db3d14$export$204155decbc90e5a;

});

parcelRegister("63fUW", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

parcelRequire("fkDf0");
var $9HZPI = parcelRequire("9HZPI");


var $a7P2i = parcelRequire("a7P2i");

var $467f5ec57f13769a$var$DEFAULT_KEY = 'cause';
var $467f5ec57f13769a$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $467f5ec57f13769a$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $467f5ec57f13769a$var$DEFAULT_KEY;
        this._limit = options.limit || $467f5ec57f13769a$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $euURg.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $k3i2h.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $467f5ec57f13769a$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $467f5ec57f13769a$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9HZPI.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $467f5ec57f13769a$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $hXuPC.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $467f5ec57f13769a$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $9HZPI.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $a7P2i.exceptionFromError)(error[key]);
    return $467f5ec57f13769a$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $hXuPC.__spread)([
        exception
    ], stack));
}
module.exports["LinkedErrors"] = $467f5ec57f13769a$export$8d1e60aaf616fb4f;

});

parcelRegister("lIIKi", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("fkDf0");
var $eZrYr = parcelRequire("eZrYr");
var $3sZrb = parcelRequire("3sZrb");
var $4eANt = parcelRequire("4eANt");


var $1cvC0 = parcelRequire("1cvC0");

var $fd006a9b38b7b6f2$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $fd006a9b38b7b6f2$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $hXuPC.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $4eANt.getGlobalObject)();
        if (this._options.setTimeout) (0, $eZrYr.fill)(global, 'setTimeout', $fd006a9b38b7b6f2$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $eZrYr.fill)(global, 'setInterval', $fd006a9b38b7b6f2$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $eZrYr.fill)(global, 'requestAnimationFrame', $fd006a9b38b7b6f2$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $eZrYr.fill)(XMLHttpRequest.prototype, 'send', $fd006a9b38b7b6f2$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $fd006a9b38b7b6f2$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($fd006a9b38b7b6f2$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $fd006a9b38b7b6f2$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $1cvC0.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $3sZrb.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fd006a9b38b7b6f2$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $1cvC0.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $3sZrb.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $fd006a9b38b7b6f2$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $eZrYr.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $3sZrb.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $eZrYr.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $3sZrb.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $1cvC0.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $fd006a9b38b7b6f2$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $4eANt.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $eZrYr.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $1cvC0.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $3sZrb.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $1cvC0.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $3sZrb.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $eZrYr.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
module.exports["TryCatch"] = $fd006a9b38b7b6f2$export$f1a018517668e6d3;

});

parcelRegister("eLUbA", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

parcelRequire("fkDf0");
var $4eANt = parcelRequire("4eANt");

var $ac1109d1eba90d5a$var$global = (0, $4eANt.getGlobalObject)();
/** UserAgent */ var $ac1109d1eba90d5a$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $euURg.addGlobalEventProcessor)(function(event) {
            if ((0, $k3i2h.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$ac1109d1eba90d5a$var$global.navigator && !$ac1109d1eba90d5a$var$global.location && !$ac1109d1eba90d5a$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $ac1109d1eba90d5a$var$global.location && $ac1109d1eba90d5a$var$global.location.href;
                var referrer = ($ac1109d1eba90d5a$var$global.document || {}).referrer;
                var userAgent = ($ac1109d1eba90d5a$var$global.navigator || {}).userAgent;
                var headers = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();
module.exports["UserAgent"] = $ac1109d1eba90d5a$export$5fba5e10934a4faf;

});

parcelRegister("lHoNr", function(module, exports) {

var $i3eBC = parcelRequire("i3eBC");


var $4EsX1 = parcelRequire("4EsX1");

function $fcc0d92f39b43ab6$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fcc0d92f39b43ab6$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fcc0d92f39b43ab6$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $4EsX1.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fcc0d92f39b43ab6$export$1cfafeee2987818b() {
    var global = (0, $i3eBC.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}
module.exports["htmlTreeAsString"] = $fcc0d92f39b43ab6$export$5647df6b7814ac86;

});

parcelRegister("i3eBC", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5Bdij = parcelRequire("5Bdij");

var $d243d62f20665ee1$var$fallbackGlobalObject = {};
function $d243d62f20665ee1$export$256479dc0cea61c4() {
    return (0, $5Bdij.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $d243d62f20665ee1$var$fallbackGlobalObject;
}
function $d243d62f20665ee1$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $d243d62f20665ee1$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
module.exports["getGlobalObject"] = $d243d62f20665ee1$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $d243d62f20665ee1$export$7e223ec222791509;

});

parcelRegister("4EsX1", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $36315ae7e10575e1$var$objectToString = Object.prototype.toString;
function $36315ae7e10575e1$export$e6127cc7fe7395c3(wat) {
    switch($36315ae7e10575e1$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $36315ae7e10575e1$export$49034edbe6b62415(wat, Error);
    }
}
function $36315ae7e10575e1$var$isBuiltin(wat, ty) {
    return $36315ae7e10575e1$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $36315ae7e10575e1$export$9f9636d330b71954(wat) {
    return $36315ae7e10575e1$var$isBuiltin(wat, 'ErrorEvent');
}
function $36315ae7e10575e1$export$ef9e2056653f0c8e(wat) {
    return $36315ae7e10575e1$var$isBuiltin(wat, 'DOMError');
}
function $36315ae7e10575e1$export$12e869b2a583f783(wat) {
    return $36315ae7e10575e1$var$isBuiltin(wat, 'DOMException');
}
function $36315ae7e10575e1$export$844ec244b1367d54(wat) {
    return $36315ae7e10575e1$var$isBuiltin(wat, 'String');
}
function $36315ae7e10575e1$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $36315ae7e10575e1$export$53b83ca8eaab0383(wat) {
    return $36315ae7e10575e1$var$isBuiltin(wat, 'Object');
}
function $36315ae7e10575e1$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $36315ae7e10575e1$export$49034edbe6b62415(wat, Event);
}
function $36315ae7e10575e1$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $36315ae7e10575e1$export$49034edbe6b62415(wat, Element);
}
function $36315ae7e10575e1$export$49841c62b9eff15(wat) {
    return $36315ae7e10575e1$var$isBuiltin(wat, 'RegExp');
}
function $36315ae7e10575e1$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $36315ae7e10575e1$export$bc2894c7158efbac(wat) {
    return $36315ae7e10575e1$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $36315ae7e10575e1$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $36315ae7e10575e1$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
module.exports["isError"] = $36315ae7e10575e1$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $36315ae7e10575e1$export$49034edbe6b62415;
module.exports["isString"] = $36315ae7e10575e1$export$844ec244b1367d54;
module.exports["isPrimitive"] = $36315ae7e10575e1$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $36315ae7e10575e1$export$53b83ca8eaab0383;
module.exports["isEvent"] = $36315ae7e10575e1$export$9671ea99bd126ace;
module.exports["isElement"] = $36315ae7e10575e1$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $36315ae7e10575e1$export$49841c62b9eff15;
module.exports["isThenable"] = $36315ae7e10575e1$export$f5b060c2914b97c8;

});

parcelRegister("4e7HY", function(module, exports) {
$parcel$export(module.exports, "logger", () => $313e72ee3fab74de$export$af88d00dbe7f521);

var $hXuPC = parcelRequire("hXuPC");

/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $55f5c0a7bbd369a3$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;



var $i3eBC = parcelRequire("i3eBC");

// TODO: Implement different loggers for different environments
var $313e72ee3fab74de$var$global = (0, $i3eBC.getGlobalObject)();
/** Prefix for logging strings */ var $313e72ee3fab74de$var$PREFIX = 'Sentry Logger ';
var $313e72ee3fab74de$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $313e72ee3fab74de$export$cda52e2a8927a2ca(callback) {
    var global = (0, $i3eBC.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $313e72ee3fab74de$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $313e72ee3fab74de$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $55f5c0a7bbd369a3$export$48a8984ec0bf2e44) $313e72ee3fab74de$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $313e72ee3fab74de$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $313e72ee3fab74de$var$global.console)[name].apply(_a, (0, $hXuPC.__spread)([
                    $313e72ee3fab74de$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $313e72ee3fab74de$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $313e72ee3fab74de$export$af88d00dbe7f521;
if (0, $55f5c0a7bbd369a3$export$48a8984ec0bf2e44) $313e72ee3fab74de$export$af88d00dbe7f521 = (0, $i3eBC.getGlobalSingleton)('logger', $313e72ee3fab74de$var$makeLogger);
else $313e72ee3fab74de$export$af88d00dbe7f521 = $313e72ee3fab74de$var$makeLogger();
module.exports["consoleSandbox"] = $313e72ee3fab74de$export$cda52e2a8927a2ca;

});

parcelRegister("laILM", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $i3eBC = parcelRequire("i3eBC");


var $a3b6c = parcelRequire("a3b6c");


var $duONw = parcelRequire("duONw");

function $f69d42749adc5b0f$export$19f53698e68b2496() {
    var global = (0, $i3eBC.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $f69d42749adc5b0f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $f69d42749adc5b0f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $f69d42749adc5b0f$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $f69d42749adc5b0f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $f69d42749adc5b0f$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $f69d42749adc5b0f$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $f69d42749adc5b0f$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $f69d42749adc5b0f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $f69d42749adc5b0f$export$d364f2020ab30578(input) {
    var match = input.match($f69d42749adc5b0f$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $f69d42749adc5b0f$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $duONw.snipLine)(line, 0);
    });
    frame.context_line = (0, $duONw.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $duONw.snipLine)(line, 0);
    });
}
function $f69d42749adc5b0f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $f69d42749adc5b0f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $a3b6c.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
module.exports["uuid4"] = $f69d42749adc5b0f$export$19f53698e68b2496;

});

parcelRegister("a3b6c", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $lHoNr = parcelRequire("lHoNr");


var $4EsX1 = parcelRequire("4EsX1");


var $duONw = parcelRequire("duONw");

function $7512cb39d7f61b65$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $7512cb39d7f61b65$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $7512cb39d7f61b65$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $7512cb39d7f61b65$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $7512cb39d7f61b65$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $7512cb39d7f61b65$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $7512cb39d7f61b65$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $7512cb39d7f61b65$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $4EsX1.isError)(value)) newObj = (0, $hXuPC.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $7512cb39d7f61b65$var$getOwnProperties(value));
    else if ((0, $4EsX1.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $hXuPC.__assign)({
            type: event_1.type,
            target: $7512cb39d7f61b65$var$serializeEventTarget(event_1.target),
            currentTarget: $7512cb39d7f61b65$var$serializeEventTarget(event_1.currentTarget)
        }, $7512cb39d7f61b65$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $4EsX1.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $7512cb39d7f61b65$var$serializeEventTarget(target) {
    try {
        return (0, $4EsX1.isElement)(target) ? (0, $lHoNr.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $7512cb39d7f61b65$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $7512cb39d7f61b65$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($7512cb39d7f61b65$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $duONw.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $duONw.truncate)(serialized, maxLength);
    }
    return '';
}
function $7512cb39d7f61b65$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $4EsX1.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $hXuPC.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $7512cb39d7f61b65$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($7512cb39d7f61b65$export$d25f2688db1bb433);
    return val;
}
function $7512cb39d7f61b65$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $4EsX1.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports["addNonEnumerableProperty"] = $7512cb39d7f61b65$export$e73679ffaf56810e;
module.exports["dropUndefinedKeys"] = $7512cb39d7f61b65$export$d25f2688db1bb433;

});

parcelRegister("duONw", function(module, exports) {

var $4EsX1 = parcelRequire("4EsX1");

function $9d357b0e094cb037$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $9d357b0e094cb037$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $9d357b0e094cb037$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $9d357b0e094cb037$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $4EsX1.isString)(value)) return false;
    if ((0, $4EsX1.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $9d357b0e094cb037$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
module.exports["truncate"] = $9d357b0e094cb037$export$6a506b36fdea397d;
module.exports["snipLine"] = $9d357b0e094cb037$export$4215662d762d6f9d;

});

parcelRegister("guynL", function(module, exports) {
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $4EsX1 = parcelRequire("4EsX1");

function $c01a1e47c25f8a74$export$1fda8aa4d135f8aa(value) {
    return new $c01a1e47c25f8a74$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $c01a1e47c25f8a74$export$78e43115b553f358(reason) {
    return new $c01a1e47c25f8a74$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $c01a1e47c25f8a74$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $4EsX1.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();
module.exports["SyncPromise"] = $c01a1e47c25f8a74$export$6f292d4960313241;

});

parcelRegister("d4v4U", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $9843c18c5c4b8b33$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
module.exports["isBrowserBundle"] = $9843c18c5c4b8b33$export$2928c40372e623c0;

});

parcelRegister("eO92b", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("i3eBC")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("i3eBC")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("4EsX1")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("4EsX1")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("4e7HY")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("4e7HY")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("laILM")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("a3b6c")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("guynL")).SyncPromise);





parcelRequire("i3eBC");


parcelRequire("4EsX1");

parcelRequire("4e7HY");


parcelRequire("laILM");


var $5Bdij = parcelRequire("5Bdij");


parcelRequire("a3b6c");








parcelRequire("guynL");


var $gBQDZ = parcelRequire("gBQDZ");






$parcel$exportWildcard(module.exports, $5Bdij);
$parcel$exportWildcard(module.exports, $gBQDZ);

});

parcelRegister("aqDlz", function(module, exports) {
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $797ada939d797e24$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
module.exports["forget"] = $797ada939d797e24$export$93c25f2590a5b540;

});

parcelRegister("xU7pz", function(module, exports) {

var $4eANt = parcelRequire("4eANt");


var $9HZPI = parcelRequire("9HZPI");

function $065e9d279c376c53$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $065e9d279c376c53$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $065e9d279c376c53$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $9HZPI.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $065e9d279c376c53$export$1cfafeee2987818b() {
    var global = (0, $4eANt.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}
module.exports["htmlTreeAsString"] = $065e9d279c376c53$export$5647df6b7814ac86;
module.exports["getLocationHref"] = $065e9d279c376c53$export$1cfafeee2987818b;

});

parcelRegister("2V24C", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $fS7TC = parcelRequire("fS7TC");


var $2mxLD = parcelRequire("2mxLD");

/** Regular expression used to parse a Dsn. */ var $2202836a0f841ec5$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $2202836a0f841ec5$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $2202836a0f841ec5$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $2202836a0f841ec5$var$dsnFromString(str) {
    var match = $2202836a0f841ec5$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $fS7TC.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $hXuPC.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $2202836a0f841ec5$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $2202836a0f841ec5$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $2202836a0f841ec5$var$validateDsn(dsn) {
    if (!(0, $2mxLD.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $fS7TC.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $fS7TC.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$2202836a0f841ec5$var$isValidProtocol(protocol)) throw new (0, $fS7TC.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $fS7TC.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $2202836a0f841ec5$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $2202836a0f841ec5$var$dsnFromString(from) : $2202836a0f841ec5$var$dsnFromComponents(from);
    $2202836a0f841ec5$var$validateDsn(components);
    return components;
}
module.exports["dsnToString"] = $2202836a0f841ec5$export$44d472fbb931a776;
module.exports["makeDsn"] = $2202836a0f841ec5$export$128827c3562ec0cb;

});

parcelRegister("27l5c", function(module, exports) {
var $18ac96daad691abb$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];
module.exports["SeverityLevels"] = $18ac96daad691abb$export$484b1ea9aec914c;

});

parcelRegister("fS7TC", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

var $4e86c743d078b8bb$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $4e86c743d078b8bb$var$setProtoOf : $4e86c743d078b8bb$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4e86c743d078b8bb$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4e86c743d078b8bb$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}


/** An error emitted by Sentry SDKs and related utilities. */ var $b8e20627cffb3659$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $4e86c743d078b8bb$export$1cb0d91350beb6cc)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);
module.exports["SentryError"] = $b8e20627cffb3659$export$5949942ba2a7c0e2;

});

parcelRegister("4eANt", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $56dzl = parcelRequire("56dzl");

var $315503574d63eae4$var$fallbackGlobalObject = {};
function $315503574d63eae4$export$256479dc0cea61c4() {
    return (0, $56dzl.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $315503574d63eae4$var$fallbackGlobalObject;
}
function $315503574d63eae4$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $315503574d63eae4$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
module.exports["getGlobalObject"] = $315503574d63eae4$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $315503574d63eae4$export$7e223ec222791509;

});

parcelRegister("1J0Am", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $2mxLD = parcelRequire("2mxLD");


var $4eANt = parcelRequire("4eANt");


var $9HZPI = parcelRequire("9HZPI");


var $cocLa = parcelRequire("cocLa");


var $eZrYr = parcelRequire("eZrYr");


var $3sZrb = parcelRequire("3sZrb");


var $6eHR6 = parcelRequire("6eHR6");

var $141a72b12ed79578$var$global = (0, $4eANt.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $141a72b12ed79578$var$handlers = {};
var $141a72b12ed79578$var$instrumented = {};
/** Instruments given API */ function $141a72b12ed79578$var$instrument(type) {
    if ($141a72b12ed79578$var$instrumented[type]) return;
    $141a72b12ed79578$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $141a72b12ed79578$var$instrumentConsole();
            break;
        case 'dom':
            $141a72b12ed79578$var$instrumentDOM();
            break;
        case 'xhr':
            $141a72b12ed79578$var$instrumentXHR();
            break;
        case 'fetch':
            $141a72b12ed79578$var$instrumentFetch();
            break;
        case 'history':
            $141a72b12ed79578$var$instrumentHistory();
            break;
        case 'error':
            $141a72b12ed79578$var$instrumentError();
            break;
        case 'unhandledrejection':
            $141a72b12ed79578$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $2mxLD.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $141a72b12ed79578$export$285b9172a3741fb7(type, callback) {
    $141a72b12ed79578$var$handlers[type] = $141a72b12ed79578$var$handlers[type] || [];
    $141a72b12ed79578$var$handlers[type].push(callback);
    $141a72b12ed79578$var$instrument(type);
}
/** JSDoc */ function $141a72b12ed79578$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$141a72b12ed79578$var$handlers[type]) return;
    try {
        for(var _b = (0, $hXuPC.__values)($141a72b12ed79578$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $2mxLD.IS_DEBUG_BUILD) && (0, $cocLa.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $3sZrb.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $141a72b12ed79578$var$instrumentConsole() {
    if (!('console' in $141a72b12ed79578$var$global)) return;
    (0, $cocLa.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $141a72b12ed79578$var$global.console)) return;
        (0, $eZrYr.fill)($141a72b12ed79578$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $141a72b12ed79578$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($141a72b12ed79578$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $141a72b12ed79578$var$instrumentFetch() {
    if (!(0, $6eHR6.supportsNativeFetch)()) return;
    (0, $eZrYr.fill)($141a72b12ed79578$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $141a72b12ed79578$var$getFetchMethod(args),
                    url: $141a72b12ed79578$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $141a72b12ed79578$var$triggerHandlers('fetch', (0, $hXuPC.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($141a72b12ed79578$var$global, args).then(function(response) {
                $141a72b12ed79578$var$triggerHandlers('fetch', (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $141a72b12ed79578$var$triggerHandlers('fetch', (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $141a72b12ed79578$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $141a72b12ed79578$var$global && (0, $9HZPI.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $141a72b12ed79578$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $141a72b12ed79578$var$global && (0, $9HZPI.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $141a72b12ed79578$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $141a72b12ed79578$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $eZrYr.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $9HZPI.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $9HZPI.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $141a72b12ed79578$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $eZrYr.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $eZrYr.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $141a72b12ed79578$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $141a72b12ed79578$var$lastHref;
/** JSDoc */ function $141a72b12ed79578$var$instrumentHistory() {
    if (!(0, $6eHR6.supportsHistory)()) return;
    var oldOnPopState = $141a72b12ed79578$var$global.onpopstate;
    $141a72b12ed79578$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $141a72b12ed79578$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $141a72b12ed79578$var$lastHref;
        $141a72b12ed79578$var$lastHref = to;
        $141a72b12ed79578$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $141a72b12ed79578$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $141a72b12ed79578$var$lastHref = to;
                $141a72b12ed79578$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $eZrYr.fill)($141a72b12ed79578$var$global.history, 'pushState', historyReplacementFunction);
    (0, $eZrYr.fill)($141a72b12ed79578$var$global.history, 'replaceState', historyReplacementFunction);
}
var $141a72b12ed79578$var$debounceDuration = 1000;
var $141a72b12ed79578$var$debounceTimerID;
var $141a72b12ed79578$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $141a72b12ed79578$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $141a72b12ed79578$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $141a72b12ed79578$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $141a72b12ed79578$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($141a72b12ed79578$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($141a72b12ed79578$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $141a72b12ed79578$var$lastCapturedEvent = event;
        } else if ($141a72b12ed79578$var$shouldShortcircuitPreviousDebounce($141a72b12ed79578$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $141a72b12ed79578$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($141a72b12ed79578$var$debounceTimerID);
        $141a72b12ed79578$var$debounceTimerID = $141a72b12ed79578$var$global.setTimeout(function() {
            $141a72b12ed79578$var$debounceTimerID = undefined;
        }, $141a72b12ed79578$var$debounceDuration);
    };
}
/** JSDoc */ function $141a72b12ed79578$var$instrumentDOM() {
    if (!('document' in $141a72b12ed79578$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $141a72b12ed79578$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $141a72b12ed79578$var$makeDOMEventHandler(triggerDOMHandler, true);
    $141a72b12ed79578$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $141a72b12ed79578$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $141a72b12ed79578$var$global[target] && $141a72b12ed79578$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $eZrYr.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $141a72b12ed79578$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $eZrYr.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $141a72b12ed79578$var$_oldOnErrorHandler = null;
/** JSDoc */ function $141a72b12ed79578$var$instrumentError() {
    $141a72b12ed79578$var$_oldOnErrorHandler = $141a72b12ed79578$var$global.onerror;
    $141a72b12ed79578$var$global.onerror = function(msg, url, line, column, error) {
        $141a72b12ed79578$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($141a72b12ed79578$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $141a72b12ed79578$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $141a72b12ed79578$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $141a72b12ed79578$var$instrumentUnhandledRejection() {
    $141a72b12ed79578$var$_oldOnUnhandledRejectionHandler = $141a72b12ed79578$var$global.onunhandledrejection;
    $141a72b12ed79578$var$global.onunhandledrejection = function(e) {
        $141a72b12ed79578$var$triggerHandlers('unhandledrejection', e);
        if ($141a72b12ed79578$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $141a72b12ed79578$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}
module.exports["addInstrumentationHandler"] = $141a72b12ed79578$export$285b9172a3741fb7;

});

parcelRegister("9HZPI", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $711817f642209ecd$var$objectToString = Object.prototype.toString;
function $711817f642209ecd$export$e6127cc7fe7395c3(wat) {
    switch($711817f642209ecd$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $711817f642209ecd$export$49034edbe6b62415(wat, Error);
    }
}
function $711817f642209ecd$var$isBuiltin(wat, ty) {
    return $711817f642209ecd$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $711817f642209ecd$export$9f9636d330b71954(wat) {
    return $711817f642209ecd$var$isBuiltin(wat, 'ErrorEvent');
}
function $711817f642209ecd$export$ef9e2056653f0c8e(wat) {
    return $711817f642209ecd$var$isBuiltin(wat, 'DOMError');
}
function $711817f642209ecd$export$12e869b2a583f783(wat) {
    return $711817f642209ecd$var$isBuiltin(wat, 'DOMException');
}
function $711817f642209ecd$export$844ec244b1367d54(wat) {
    return $711817f642209ecd$var$isBuiltin(wat, 'String');
}
function $711817f642209ecd$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $711817f642209ecd$export$53b83ca8eaab0383(wat) {
    return $711817f642209ecd$var$isBuiltin(wat, 'Object');
}
function $711817f642209ecd$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $711817f642209ecd$export$49034edbe6b62415(wat, Event);
}
function $711817f642209ecd$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $711817f642209ecd$export$49034edbe6b62415(wat, Element);
}
function $711817f642209ecd$export$49841c62b9eff15(wat) {
    return $711817f642209ecd$var$isBuiltin(wat, 'RegExp');
}
function $711817f642209ecd$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $711817f642209ecd$export$bc2894c7158efbac(wat) {
    return $711817f642209ecd$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $711817f642209ecd$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $711817f642209ecd$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
module.exports["isError"] = $711817f642209ecd$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $711817f642209ecd$export$49034edbe6b62415;
module.exports["isErrorEvent"] = $711817f642209ecd$export$9f9636d330b71954;
module.exports["isDOMError"] = $711817f642209ecd$export$ef9e2056653f0c8e;
module.exports["isDOMException"] = $711817f642209ecd$export$12e869b2a583f783;
module.exports["isString"] = $711817f642209ecd$export$844ec244b1367d54;
module.exports["isPrimitive"] = $711817f642209ecd$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $711817f642209ecd$export$53b83ca8eaab0383;
module.exports["isEvent"] = $711817f642209ecd$export$9671ea99bd126ace;
module.exports["isElement"] = $711817f642209ecd$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $711817f642209ecd$export$49841c62b9eff15;
module.exports["isThenable"] = $711817f642209ecd$export$f5b060c2914b97c8;
module.exports["isSyntheticEvent"] = $711817f642209ecd$export$bc2894c7158efbac;
module.exports["isNaN"] = $711817f642209ecd$export$c9f5652083b8129d;

});

parcelRegister("cocLa", function(module, exports) {
$parcel$export(module.exports, "logger", () => $90519fbe5257db5a$export$af88d00dbe7f521);

var $hXuPC = parcelRequire("hXuPC");


var $2mxLD = parcelRequire("2mxLD");


var $4eANt = parcelRequire("4eANt");

// TODO: Implement different loggers for different environments
var $90519fbe5257db5a$var$global = (0, $4eANt.getGlobalObject)();
/** Prefix for logging strings */ var $90519fbe5257db5a$var$PREFIX = 'Sentry Logger ';
var $90519fbe5257db5a$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $90519fbe5257db5a$export$cda52e2a8927a2ca(callback) {
    var global = (0, $4eANt.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $90519fbe5257db5a$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $90519fbe5257db5a$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $2mxLD.IS_DEBUG_BUILD) $90519fbe5257db5a$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $90519fbe5257db5a$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $90519fbe5257db5a$var$global.console)[name].apply(_a, (0, $hXuPC.__spread)([
                    $90519fbe5257db5a$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $90519fbe5257db5a$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $90519fbe5257db5a$export$af88d00dbe7f521;
if (0, $2mxLD.IS_DEBUG_BUILD) $90519fbe5257db5a$export$af88d00dbe7f521 = (0, $4eANt.getGlobalSingleton)('logger', $90519fbe5257db5a$var$makeLogger);
else $90519fbe5257db5a$export$af88d00dbe7f521 = $90519fbe5257db5a$var$makeLogger();
module.exports["CONSOLE_LEVELS"] = $90519fbe5257db5a$export$2a2b1d2252a69ecb;

});

parcelRegister("e1n4T", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $a3530f80ddca9b31$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports["memoBuilder"] = $a3530f80ddca9b31$export$8115b0b78e956ab3;

});

parcelRegister("MPsF3", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $4eANt = parcelRequire("4eANt");


var $eZrYr = parcelRequire("eZrYr");


var $jsTR9 = parcelRequire("jsTR9");

function $092c66f276bd2e0e$export$19f53698e68b2496() {
    var global = (0, $4eANt.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $092c66f276bd2e0e$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $092c66f276bd2e0e$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $092c66f276bd2e0e$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $092c66f276bd2e0e$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $092c66f276bd2e0e$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $092c66f276bd2e0e$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $092c66f276bd2e0e$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $092c66f276bd2e0e$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $092c66f276bd2e0e$export$d364f2020ab30578(input) {
    var match = input.match($092c66f276bd2e0e$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $092c66f276bd2e0e$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $jsTR9.snipLine)(line, 0);
    });
    frame.context_line = (0, $jsTR9.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $jsTR9.snipLine)(line, 0);
    });
}
function $092c66f276bd2e0e$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $092c66f276bd2e0e$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $eZrYr.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
module.exports["uuid4"] = $092c66f276bd2e0e$export$19f53698e68b2496;
module.exports["parseUrl"] = $092c66f276bd2e0e$export$7a5253c0f62e0150;
module.exports["getEventDescription"] = $092c66f276bd2e0e$export$4157119e2b157127;
module.exports["addExceptionTypeValue"] = $092c66f276bd2e0e$export$f26508487bf83ee7;
module.exports["addExceptionMechanism"] = $092c66f276bd2e0e$export$c69a9a0313b03bb1;
module.exports["checkOrSetAlreadyCaught"] = $092c66f276bd2e0e$export$6de4ffac6a2f1098;

});

parcelRegister("gqhQh", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $9HZPI = parcelRequire("9HZPI");


var $e1n4T = parcelRequire("e1n4T");


var $eZrYr = parcelRequire("eZrYr");


var $3sZrb = parcelRequire("3sZrb");

function $bf4cea24319a3d86$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $bf4cea24319a3d86$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $bf4cea24319a3d86$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $bf4cea24319a3d86$export$a3295358bff77e(object, depth);
    if ($bf4cea24319a3d86$var$jsonSize(normalized) > maxSize) return $bf4cea24319a3d86$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $bf4cea24319a3d86$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $e1n4T.memoBuilder)();
    var _a = (0, $hXuPC.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $9HZPI.isNaN)(value)) return value;
    var stringified = $bf4cea24319a3d86$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $9HZPI.isError)(value) || (0, $9HZPI.isEvent)(value) ? (0, $eZrYr.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $bf4cea24319a3d86$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $bf4cea24319a3d86$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $9HZPI.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $3sZrb.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $bf4cea24319a3d86$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $bf4cea24319a3d86$var$jsonSize(value) {
    return $bf4cea24319a3d86$var$utf8Length(JSON.stringify(value));
}
module.exports["normalize"] = $bf4cea24319a3d86$export$a3295358bff77e;
module.exports["normalizeToSize"] = $bf4cea24319a3d86$export$23fbbb20bed71033;

});

parcelRegister("eZrYr", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $xU7pz = parcelRequire("xU7pz");


var $9HZPI = parcelRequire("9HZPI");


var $jsTR9 = parcelRequire("jsTR9");

function $ae9c763e4ba9dbc6$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $ae9c763e4ba9dbc6$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $ae9c763e4ba9dbc6$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $ae9c763e4ba9dbc6$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $ae9c763e4ba9dbc6$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $ae9c763e4ba9dbc6$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $ae9c763e4ba9dbc6$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $ae9c763e4ba9dbc6$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $9HZPI.isError)(value)) newObj = (0, $hXuPC.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $ae9c763e4ba9dbc6$var$getOwnProperties(value));
    else if ((0, $9HZPI.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $hXuPC.__assign)({
            type: event_1.type,
            target: $ae9c763e4ba9dbc6$var$serializeEventTarget(event_1.target),
            currentTarget: $ae9c763e4ba9dbc6$var$serializeEventTarget(event_1.currentTarget)
        }, $ae9c763e4ba9dbc6$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $9HZPI.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $ae9c763e4ba9dbc6$var$serializeEventTarget(target) {
    try {
        return (0, $9HZPI.isElement)(target) ? (0, $xU7pz.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $ae9c763e4ba9dbc6$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $ae9c763e4ba9dbc6$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($ae9c763e4ba9dbc6$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jsTR9.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jsTR9.truncate)(serialized, maxLength);
    }
    return '';
}
function $ae9c763e4ba9dbc6$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $9HZPI.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $hXuPC.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $ae9c763e4ba9dbc6$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($ae9c763e4ba9dbc6$export$d25f2688db1bb433);
    return val;
}
function $ae9c763e4ba9dbc6$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9HZPI.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports["fill"] = $ae9c763e4ba9dbc6$export$9563e054e6f787fb;
module.exports["markFunctionWrapped"] = $ae9c763e4ba9dbc6$export$5c1499e2e5d010ae;
module.exports["addNonEnumerableProperty"] = $ae9c763e4ba9dbc6$export$e73679ffaf56810e;
module.exports["getOriginalFunction"] = $ae9c763e4ba9dbc6$export$e6cc1e135e2092e5;
module.exports["urlEncode"] = $ae9c763e4ba9dbc6$export$9ef804feabbcbaf1;
module.exports["convertToPlainObject"] = $ae9c763e4ba9dbc6$export$62ff257738bf57f5;
module.exports["extractExceptionKeysForMessage"] = $ae9c763e4ba9dbc6$export$b0244d5063c0b61b;

});

parcelRegister("8TkNe", function(module, exports) {

var $fS7TC = parcelRequire("fS7TC");


var $jzoXR = parcelRequire("jzoXR");

function $679396e0de544809$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $jzoXR.rejectedSyncPromise)(new (0, $fS7TC.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $jzoXR.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $jzoXR.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}
module.exports["makePromiseBuffer"] = $679396e0de544809$export$85a4f67f852183e6;

});

parcelRegister("eEOR0", function(module, exports) {

var $cs0rL = parcelRequire("cs0rL");


var $27l5c = parcelRequire("27l5c");

function $aabc3fa19a8cbcf0$var$isSupportedSeverity(level) {
    return (0, $27l5c.SeverityLevels).indexOf(level) !== -1;
}
function $aabc3fa19a8cbcf0$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $cs0rL.Severity).Warning;
    if ($aabc3fa19a8cbcf0$var$isSupportedSeverity(level)) return level;
    return (0, $cs0rL.Severity).Log;
}
module.exports["severityFromString"] = $aabc3fa19a8cbcf0$export$e01cef29b4327697;

});

parcelRegister("3sZrb", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

var $2863a4cd65a4b226$var$STACKTRACE_LIMIT = 50;
function $2863a4cd65a4b226$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $hXuPC.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $hXuPC.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $2863a4cd65a4b226$export$c55c24c0eeba0205(frames);
    };
}
function $2863a4cd65a4b226$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $2863a4cd65a4b226$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $2863a4cd65a4b226$var$defaultFunctionName = '<anonymous>';
function $2863a4cd65a4b226$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $2863a4cd65a4b226$var$defaultFunctionName;
        return fn.name || $2863a4cd65a4b226$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $2863a4cd65a4b226$var$defaultFunctionName;
    }
}
module.exports["createStackParser"] = $2863a4cd65a4b226$export$a5739666fb2d03d4;
module.exports["getFunctionName"] = $2863a4cd65a4b226$export$aad197c7121a6651;

});

parcelRegister("aXefL", function(module, exports) {
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $7f9a78739c59e81b$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}
module.exports["eventStatusFromHttpCode"] = $7f9a78739c59e81b$export$82713360d763c449;

});

parcelRegister("jsTR9", function(module, exports) {

var $9HZPI = parcelRequire("9HZPI");

function $e2bbf5c0e8e9dd27$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $e2bbf5c0e8e9dd27$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $e2bbf5c0e8e9dd27$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $e2bbf5c0e8e9dd27$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $9HZPI.isString)(value)) return false;
    if ((0, $9HZPI.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $e2bbf5c0e8e9dd27$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
module.exports["truncate"] = $e2bbf5c0e8e9dd27$export$6a506b36fdea397d;
module.exports["snipLine"] = $e2bbf5c0e8e9dd27$export$4215662d762d6f9d;
module.exports["safeJoin"] = $e2bbf5c0e8e9dd27$export$465e9d514283d4fd;
module.exports["isMatchingPattern"] = $e2bbf5c0e8e9dd27$export$cdded5b28a5f8c6d;

});

parcelRegister("6eHR6", function(module, exports) {

var $2mxLD = parcelRequire("2mxLD");


var $4eANt = parcelRequire("4eANt");


var $cocLa = parcelRequire("cocLa");

function $48a611b072b2b550$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $48a611b072b2b550$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $48a611b072b2b550$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $48a611b072b2b550$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $4eANt.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $48a611b072b2b550$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $48a611b072b2b550$export$c82d238e23c40b21() {
    if (!$48a611b072b2b550$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $4eANt.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($48a611b072b2b550$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $48a611b072b2b550$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $2mxLD.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $48a611b072b2b550$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $4eANt.getGlobalObject)();
}
function $48a611b072b2b550$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$48a611b072b2b550$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $48a611b072b2b550$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $4eANt.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
module.exports["supportsFetch"] = $48a611b072b2b550$export$edf3cb81fd7d2a3e;
module.exports["isNativeFetch"] = $48a611b072b2b550$export$18cf36ed71d733e7;
module.exports["supportsNativeFetch"] = $48a611b072b2b550$export$c82d238e23c40b21;
module.exports["supportsReferrerPolicy"] = $48a611b072b2b550$export$2d308b428295192f;
module.exports["supportsHistory"] = $48a611b072b2b550$export$67fc34576016d6ec;

});

parcelRegister("jzoXR", function(module, exports) {
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $9HZPI = parcelRequire("9HZPI");

function $e3f4a6a8dd10eace$export$1fda8aa4d135f8aa(value) {
    return new $e3f4a6a8dd10eace$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $e3f4a6a8dd10eace$export$78e43115b553f358(reason) {
    return new $e3f4a6a8dd10eace$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $e3f4a6a8dd10eace$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $9HZPI.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();
module.exports["resolvedSyncPromise"] = $e3f4a6a8dd10eace$export$1fda8aa4d135f8aa;
module.exports["SyncPromise"] = $e3f4a6a8dd10eace$export$6f292d4960313241;
module.exports["rejectedSyncPromise"] = $e3f4a6a8dd10eace$export$78e43115b553f358;

});

parcelRegister("d4wHl", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $98450342c93b313b$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
module.exports["isBrowserBundle"] = $98450342c93b313b$export$2928c40372e623c0;

});

parcelRegister("2yJF3", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $9HZPI = parcelRequire("9HZPI");

function $1dd22d157d9b1383$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $1dd22d157d9b1383$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $hXuPC.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $hXuPC.__spread)(items, [
            newItem
        ])
    ];
}
function $1dd22d157d9b1383$export$d84939284bbafcd4(envelope) {
    var _a = (0, $hXuPC.__read)(envelope, 2), _b = (0, $hXuPC.__read)(_a[1], 1), _c = (0, $hXuPC.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $1dd22d157d9b1383$export$32f9b428425aac85(envelope) {
    var _a = (0, $hXuPC.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $hXuPC.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $9HZPI.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}
module.exports["createEnvelope"] = $1dd22d157d9b1383$export$f93f7f385160c44e;
module.exports["getEnvelopeType"] = $1dd22d157d9b1383$export$d84939284bbafcd4;
module.exports["serializeEnvelope"] = $1dd22d157d9b1383$export$32f9b428425aac85;

});

parcelRegister("1D7cA", function(module, exports) {

var $2yJF3 = parcelRequire("2yJF3");


var $aYCCb = parcelRequire("aYCCb");

function $12ff0523ac8d29fb$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $aYCCb.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2yJF3.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports["createClientReportEnvelope"] = $12ff0523ac8d29fb$export$f3b9ed77c03eeb00;

});

parcelRegister("bc0x7", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

var $82613a910e20d35f$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $82613a910e20d35f$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $82613a910e20d35f$export$b09ce39faaeb1e7c;
}
function $82613a910e20d35f$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $82613a910e20d35f$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $82613a910e20d35f$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $82613a910e20d35f$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $hXuPC.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $hXuPC.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $hXuPC.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $82613a910e20d35f$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}
module.exports["disabledUntil"] = $82613a910e20d35f$export$b89fc7b2e4c799e7;
module.exports["isRateLimited"] = $82613a910e20d35f$export$6c91fec22056810a;
module.exports["updateRateLimits"] = $82613a910e20d35f$export$699aff705e0d49d4;

});

parcelRegister("cieCg", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $8f3280ea6b7a9cf4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $8f3280ea6b7a9cf4$export$48a8984ec0bf2e44;

});

parcelRegister("kGXHg", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("fkDf0");
var $2yJF3 = parcelRequire("2yJF3");
var $2V24C = parcelRequire("2V24C");
var $gqhQh = parcelRequire("gqhQh");


var $is9T0 = parcelRequire("is9T0");

/** Extract sdk info from from the API metadata */ function $f106096964386cac$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $f106096964386cac$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $hXuPC.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $hXuPC.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $f106096964386cac$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $f106096964386cac$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $2V24C.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $2yJF3.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $f106096964386cac$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $hXuPC.__read)($f106096964386cac$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $2yJF3.serializeEnvelope)(envelope),
        type: type,
        url: (0, $is9T0.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $f106096964386cac$export$c31057337a18010f(event, api) {
    var sdkInfo = $f106096964386cac$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $f106096964386cac$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $2V24C.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $2yJF3.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $f106096964386cac$export$2006389de558b996(event, api) {
    var sdkInfo = $f106096964386cac$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $f106096964386cac$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $gqhQh.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $is9T0.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $is9T0.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $2V24C.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $2yJF3.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $2yJF3.serializeEnvelope)(envelope);
    }
    return req;
}
module.exports["createSessionEnvelope"] = $f106096964386cac$export$124b03c077baa2f3;
module.exports["sessionToSentryRequest"] = $f106096964386cac$export$977ee6eda1884ec3;
module.exports["createEventEnvelope"] = $f106096964386cac$export$c31057337a18010f;
module.exports["eventToSentryRequest"] = $f106096964386cac$export$2006389de558b996;

});

parcelRegister("is9T0", function(module, exports) {
parcelRequire("fkDf0");
var $2V24C = parcelRequire("2V24C");
var $eZrYr = parcelRequire("eZrYr");

var $d6f282afeb361d8d$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $d6f282afeb361d8d$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $2V24C.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $d6f282afeb361d8d$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $d6f282afeb361d8d$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $d6f282afeb361d8d$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $d6f282afeb361d8d$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $d6f282afeb361d8d$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $2V24C.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $d6f282afeb361d8d$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $d6f282afeb361d8d$var$_getIngestEndpoint(dsn, target) {
    return "" + $d6f282afeb361d8d$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $d6f282afeb361d8d$var$_encodedAuth(dsn) {
    return (0, $eZrYr.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $d6f282afeb361d8d$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $d6f282afeb361d8d$var$getStoreEndpoint(dsn) {
    return $d6f282afeb361d8d$var$_getIngestEndpoint(dsn, 'store');
}
function $d6f282afeb361d8d$export$c1677e22ac2217a5(dsn) {
    return $d6f282afeb361d8d$var$getStoreEndpoint(dsn) + "?" + $d6f282afeb361d8d$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $d6f282afeb361d8d$var$_getEnvelopeEndpoint(dsn) {
    return $d6f282afeb361d8d$var$_getIngestEndpoint(dsn, 'envelope');
}
function $d6f282afeb361d8d$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $d6f282afeb361d8d$var$_getEnvelopeEndpoint(dsn) + "?" + $d6f282afeb361d8d$var$_encodedAuth(dsn);
}
function $d6f282afeb361d8d$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $d6f282afeb361d8d$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $d6f282afeb361d8d$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $2V24C.makeDsn)(dsnLike);
    var endpoint = $d6f282afeb361d8d$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $2V24C.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}
module.exports["getStoreEndpointWithUrlEncodedAuth"] = $d6f282afeb361d8d$export$c1677e22ac2217a5;
module.exports["getEnvelopeEndpointWithUrlEncodedAuth"] = $d6f282afeb361d8d$export$9964600bfe84e6a3;
module.exports["initAPIDetails"] = $d6f282afeb361d8d$export$ad00a06efb2a29cb;
module.exports["getReportDialogEndpoint"] = $d6f282afeb361d8d$export$671c7ed8e40a7a57;

});

parcelRegister("hoi63", function(module, exports) {
parcelRequire("fkDf0");
var $aqDlz = parcelRequire("aqDlz");
var $4eANt = parcelRequire("4eANt");
var $6eHR6 = parcelRequire("6eHR6");
var $cocLa = parcelRequire("cocLa");


var $cieCg = parcelRequire("cieCg");

var $ca92b732fc419cb8$var$global = (0, $4eANt.getGlobalObject)();
var $ca92b732fc419cb8$var$cachedFetchImpl;
function $ca92b732fc419cb8$export$8be2119ce08e3379() {
    if ($ca92b732fc419cb8$var$cachedFetchImpl) return $ca92b732fc419cb8$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $6eHR6.isNativeFetch)($ca92b732fc419cb8$var$global.fetch)) return $ca92b732fc419cb8$var$cachedFetchImpl = $ca92b732fc419cb8$var$global.fetch.bind($ca92b732fc419cb8$var$global);
    var document = $ca92b732fc419cb8$var$global.document;
    var fetchImpl = $ca92b732fc419cb8$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $cieCg.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $ca92b732fc419cb8$var$cachedFetchImpl = fetchImpl.bind($ca92b732fc419cb8$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $ca92b732fc419cb8$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($ca92b732fc419cb8$var$global && $ca92b732fc419cb8$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $ca92b732fc419cb8$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $ca92b732fc419cb8$var$global.navigator.sendBeacon.bind($ca92b732fc419cb8$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $6eHR6.supportsFetch)()) {
        var fetch_1 = $ca92b732fc419cb8$export$8be2119ce08e3379();
        return (0, $aqDlz.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}
module.exports["getNativeFetchImplementation"] = $ca92b732fc419cb8$export$8be2119ce08e3379;
module.exports["sendReport"] = $ca92b732fc419cb8$export$84bb63b2c17ec44d;

});

parcelRegister("UVxe5", function(module, exports) {
parcelRequire("fkDf0");
var $bc0x7 = parcelRequire("bc0x7");
var $aXefL = parcelRequire("aXefL");
var $2yJF3 = parcelRequire("2yJF3");
var $8TkNe = parcelRequire("8TkNe");
var $jzoXR = parcelRequire("jzoXR");

var $0ab1dc4fcce64c98$export$d8a725a7dce95622 = 'error';
var $0ab1dc4fcce64c98$export$99adc6fe67a3c63e = 'transaction';
var $0ab1dc4fcce64c98$export$9d7ad34f132fe68f = 'attachment';
var $0ab1dc4fcce64c98$export$42d9e7b5fc564c45 = 'session';
var $0ab1dc4fcce64c98$export$e515cf6dfd2f98b8 = 30;
function $0ab1dc4fcce64c98$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $8TkNe.makePromiseBuffer)(options.bufferSize || $0ab1dc4fcce64c98$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $2yJF3.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $2yJF3.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $bc0x7.isRateLimited)(rateLimits, category)) return (0, $jzoXR.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $0ab1dc4fcce64c98$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $aXefL.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $bc0x7.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $jzoXR.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $jzoXR.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $0ab1dc4fcce64c98$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $0ab1dc4fcce64c98$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $bc0x7.disabledUntil)(rateLimits, category)).toISOString();
}
module.exports["createTransport"] = $0ab1dc4fcce64c98$export$d09f50d9ab7f7b69;

});

parcelRegister("2TDhi", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $21bf2fa1e935e717$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $21bf2fa1e935e717$export$48a8984ec0bf2e44;

});

parcelRegister("eQWVr", function(module, exports) {
parcelRequire("fkDf0");
var $eZrYr = parcelRequire("eZrYr");

var $ad03a1691980a55b$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $ad03a1691980a55b$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $ad03a1691980a55b$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $eZrYr.getOriginalFunction)(this) || this;
            return $ad03a1691980a55b$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();
module.exports["FunctionToString"] = $ad03a1691980a55b$export$da4704525c20ae79;

});

parcelRegister("22rCx", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");

parcelRequire("fkDf0");
var $MPsF3 = parcelRequire("MPsF3");
var $jsTR9 = parcelRequire("jsTR9");
var $cocLa = parcelRequire("cocLa");


var $2TDhi = parcelRequire("2TDhi");

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $17c1318bef58ac53$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $17c1318bef58ac53$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $17c1318bef58ac53$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $17c1318bef58ac53$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $17c1318bef58ac53$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $hXuPC.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $hXuPC.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $hXuPC.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $17c1318bef58ac53$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $17c1318bef58ac53$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $17c1318bef58ac53$var$_isSentryError(event)) {
        (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $MPsF3.getEventDescription)(event));
        return true;
    }
    if ($17c1318bef58ac53$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $MPsF3.getEventDescription)(event));
        return true;
    }
    if ($17c1318bef58ac53$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $MPsF3.getEventDescription)(event) + ".\nUrl: " + $17c1318bef58ac53$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$17c1318bef58ac53$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $MPsF3.getEventDescription)(event) + ".\nUrl: " + $17c1318bef58ac53$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $17c1318bef58ac53$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $17c1318bef58ac53$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $jsTR9.isMatchingPattern)(message, pattern);
        });
    });
}
function $17c1318bef58ac53$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $17c1318bef58ac53$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $jsTR9.isMatchingPattern)(url, pattern);
    });
}
function $17c1318bef58ac53$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $17c1318bef58ac53$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $jsTR9.isMatchingPattern)(url, pattern);
    });
}
function $17c1318bef58ac53$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).error("Cannot extract message for event " + (0, $MPsF3.getEventDescription)(event));
        return [];
    }
    return [];
}
function $17c1318bef58ac53$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $17c1318bef58ac53$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $17c1318bef58ac53$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $17c1318bef58ac53$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $17c1318bef58ac53$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $2TDhi.IS_DEBUG_BUILD) && (0, $cocLa.logger).error("Cannot extract url for event " + (0, $MPsF3.getEventDescription)(event));
        return null;
    }
}
module.exports["InboundFilters"] = $17c1318bef58ac53$export$2ffbb5359dcc6be4;

});

parcelRegister("2mxLD", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $1b87d4556c3770eb$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $1b87d4556c3770eb$export$48a8984ec0bf2e44;

});


$parcel$global.rlb("h3ABO")
//# sourceMappingURL=esm.2b2efc3c.js.map
